<template>
  <div class="upload-container">
    <div class="upload-area">
      <div class="upload-box" @click="uploadImage">
        <img
          class="upload-icon"
          src="../..//assets/imgs/recharge/icon_upload.png"
          alt=""
        />
        <div class="upload-text">上传汇款凭证</div>
      </div>
      <div class="uploaded-box" v-if="voucher">
        <div class="pic-name">{{ voucher }}</div>
        <div class="pic-preview" @click="previewPic">预览</div>
        <div class="pic-delete" @click="deletePic">删除</div>
      </div>
    </div>
    <div class="upload-tips">支持.jpg、.png 格式文件，大小不超过 5M</div>
  </div>
</template>
<script>
import fileService from '../../../src/services/file-service';
import uploadFileService from '../../../src/services/upload-file-service';

export default {
  components: {},
  props: {
    peerInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      voucher: '',
      voucherUrl: '',
    };
  },
  watch: {},
  computed: {},
  created() {},
  methods: {
    async uploadImage() {
      const options = {
        accept: 'image/jpeg,image/png',
        size: 1024 * 1024 * 5,
      };
      const file = await fileService.chooseFile(options);
      this.voucher = file.name;
      uploadFileService
        .uploadFileWithOssout(file, false, { noKey: true })
        .then((res) => {
          this.voucherUrl = `https://${res.oss_out}/${res.key}`;
          // this.$emit('uploadImage', this.voucherUrl);
          this.$emit('uploadImage', res.key);
        });
    },

    previewPic() {
      window.open(this.voucherUrl, '_blank');
    },

    deletePic() {
      this.$confirm('是否确定删除该文件？', '操作确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          this.voucher = '';
          this.voucherUrl = '';
          this.$emit('uploadImage', this.voucherUrl);
          this.$message({
            type: 'success',
            message: '删除成功',
          });
        })
        .catch(() => {
          console.log('已取消删除');
        });
    },
  },
};
</script>
<style scoped lang="less">
.upload-area {
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  .upload-box {
    width: 168px;
    height: 40px;
    background: #f4faff;
    border-radius: 2px;
    border: 1px dashed #599fff;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
    .upload-icon {
      display: block;
      width: 20px;
      height: 20px;
    }
    .upload-text {
      font-weight: 400;
      font-size: 14px;
      color: #2f333d;
    }
    &:hover {
      opacity: 0.8;
      cursor: pointer;
    }
  }
  .uploaded-box {
    display: flex;
    justify-content: flex-start;
    height: 40px;
    align-items: center;
    gap: 8px;
    font-weight: 400;
    font-size: 14px;
    .pic-name {
      color: #2f333d;
      max-width: 120px;
      line-height: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .pic-preview,
    .pic-delete {
      color: #599fff;
      &:hover {
        cursor: pointer;
        opacity: 0.86;
      }
    }
  }
}
.upload-tips {
  font-weight: 400;
  font-size: 12px;
  color: #91999f;
}
#voucher-box {
  /deep/.el-dialog__header {
    display: block;
    padding: 20px;
    .el-dialog__title{
      color: #fff;
    }
  }

  /deep/.el-dialog__body {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px 20px;
    max-height: 500px;
    overflow: hidden;
    .preview-container {
      width: 100%;
      height: 440px;
      margin: 0 auto;
      border: 1px solid #e9eef2;
      border-radius: 8px;
      overflow: scroll;
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/upload-voucher.vue